import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

function Exercises() {
  const API_URL = process.env.REACT_APP_API_URL;
  const [exercises, setExercises] = useState([]);
  const { id } = useParams();  // Récupère l'ID du cours depuis l'URL

  useEffect(() => {
    // Appel à l'API pour récupérer les exercices du cours
    axios.get(`${API_URL}/cours/api/exercises/?course=${id}`)
      .then(response => {
        setExercises(response.data);
      })
      .catch(error => {
        console.error("Erreur lors de la récupération des exercices :", error);
      });
  }, [id]);

  return (
    <div className="exercises">
      <h1>Liste des exercices</h1>
      <ul>
        {exercises.map(exercise => (
          <li key={exercise.id}>
            {exercise.question_type} : {exercise.question}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Exercises;
